import { useEffect, useState } from "react";
import axios from "axios";
import { Save } from "lucide-react";
import ImageUploader from "@/components/ImageUploader";

const API = process.env.REACT_APP_BACKEND_URL;
const getHeaders = () => ({ Authorization: `Bearer ${localStorage.getItem("bct_token")}` });

export default function AdminAbout() {
  const [form, setForm] = useState(null);
  const [loading, setLoading] = useState(false);
  const [saved, setSaved] = useState(false);
  const [tab, setTab] = useState("kurumsal");

  useEffect(() => {
    axios.get(`${API}/api/about`).then((r) => setForm(r.data));
  }, []);

  const handleSave = async () => {
    setLoading(true);
    try {
      await axios.put(`${API}/api/admin/about`, form, { headers: getHeaders(), withCredentials: true });
      setSaved(true);
      setTimeout(() => setSaved(false), 3000);
    } catch { alert("Hata"); }
    finally { setLoading(false); }
  };

  if (!form) return null;

  const tabs = [
    { key: "kurumsal", label: "Kurumsal" },
    { key: "misyon", label: "Misyonumuz" },
    { key: "vizyon", label: "Vizyonumuz" },
    { key: "istatistik", label: "İstatistikler" },
  ];

  return (
    <div data-testid="admin-about">
      <div className="flex items-center justify-between mb-6">
        <h1 className="text-2xl font-bold text-white" style={{ fontFamily: "Outfit" }}>Hakkımızda / Kurumsal</h1>
        <div className="flex items-center gap-3">
          {saved && <span className="text-emerald-400 text-sm">Kaydedildi!</span>}
          <button onClick={handleSave} disabled={loading} className="flex items-center gap-2 bg-[#FF5A00] hover:bg-[#e64f00] text-white px-4 py-2.5 rounded-xl text-sm font-semibold transition-colors disabled:opacity-50" data-testid="about-save-btn">
            <Save size={14} /> {loading ? "Kaydediliyor..." : "Kaydet"}
          </button>
        </div>
      </div>

      {/* Tabs */}
      <div className="flex gap-1 mb-6 bg-[#161923] rounded-xl p-1 w-fit" data-testid="about-tabs">
        {tabs.map((t) => (
          <button key={t.key} onClick={() => setTab(t.key)} className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors ${tab === t.key ? "bg-[#FF5A00] text-white" : "text-slate-400 hover:text-white"}`} style={{ fontFamily: "Outfit" }} data-testid={`about-tab-${t.key}`}>
            {t.label}
          </button>
        ))}
      </div>

      <div className="bg-[#161923] border border-white/5 rounded-xl p-6 max-w-3xl">
        {tab === "kurumsal" && (
          <div className="space-y-5" data-testid="about-kurumsal-form">
            <div>
              <label className="text-xs font-semibold text-slate-400 uppercase tracking-wider mb-2 block">Ana Başlık</label>
              <input type="text" value={form.title} onChange={(e) => setForm({ ...form, title: e.target.value })} className="admin-input" data-testid="about-title" />
            </div>
            <div>
              <label className="text-xs font-semibold text-slate-400 uppercase tracking-wider mb-2 block">Birinci Paragraf</label>
              <textarea value={form.text} onChange={(e) => setForm({ ...form, text: e.target.value })} rows={4} className="admin-input resize-none" data-testid="about-text" />
            </div>
            <div>
              <label className="text-xs font-semibold text-slate-400 uppercase tracking-wider mb-2 block">İkinci Paragraf</label>
              <textarea value={form.text2} onChange={(e) => setForm({ ...form, text2: e.target.value })} rows={4} className="admin-input resize-none" data-testid="about-text2" />
            </div>
            <ImageUploader value={form.image} onChange={(v) => setForm({ ...form, image: v })} label="Hakkımızda Görseli" />
          </div>
        )}

        {tab === "misyon" && (
          <div className="space-y-5" data-testid="about-misyon-form">
            <div>
              <label className="text-xs font-semibold text-slate-400 uppercase tracking-wider mb-2 block">Misyon Başlığı</label>
              <input type="text" value={form.mission_title} onChange={(e) => setForm({ ...form, mission_title: e.target.value })} className="admin-input" data-testid="about-mission-title" />
            </div>
            <div>
              <label className="text-xs font-semibold text-slate-400 uppercase tracking-wider mb-2 block">Misyon Metni</label>
              <textarea value={form.mission_text} onChange={(e) => setForm({ ...form, mission_text: e.target.value })} rows={6} className="admin-input resize-none" data-testid="about-mission-text" />
            </div>
            <ImageUploader value={form.mission_image} onChange={(v) => setForm({ ...form, mission_image: v })} label="Misyon Görseli" />
          </div>
        )}

        {tab === "vizyon" && (
          <div className="space-y-5" data-testid="about-vizyon-form">
            <div>
              <label className="text-xs font-semibold text-slate-400 uppercase tracking-wider mb-2 block">Vizyon Başlığı</label>
              <input type="text" value={form.vision_title} onChange={(e) => setForm({ ...form, vision_title: e.target.value })} className="admin-input" data-testid="about-vision-title" />
            </div>
            <div>
              <label className="text-xs font-semibold text-slate-400 uppercase tracking-wider mb-2 block">Vizyon Metni</label>
              <textarea value={form.vision_text} onChange={(e) => setForm({ ...form, vision_text: e.target.value })} rows={6} className="admin-input resize-none" data-testid="about-vision-text" />
            </div>
            <ImageUploader value={form.vision_image} onChange={(v) => setForm({ ...form, vision_image: v })} label="Vizyon Görseli" />
          </div>
        )}

        {tab === "istatistik" && (
          <div className="space-y-5" data-testid="about-stats-form">
            <div className="grid grid-cols-2 gap-4">
              <div>
                <label className="text-xs font-semibold text-slate-400 uppercase tracking-wider mb-2 block">Yıllık Deneyim</label>
                <input type="text" value={form.stat_years} onChange={(e) => setForm({ ...form, stat_years: e.target.value })} className="admin-input" data-testid="about-stat-years" />
              </div>
              <div>
                <label className="text-xs font-semibold text-slate-400 uppercase tracking-wider mb-2 block">Tamamlanan Proje</label>
                <input type="text" value={form.stat_projects} onChange={(e) => setForm({ ...form, stat_projects: e.target.value })} className="admin-input" data-testid="about-stat-projects" />
              </div>
              <div>
                <label className="text-xs font-semibold text-slate-400 uppercase tracking-wider mb-2 block">Mutlu Müşteri</label>
                <input type="text" value={form.stat_clients} onChange={(e) => setForm({ ...form, stat_clients: e.target.value })} className="admin-input" data-testid="about-stat-clients" />
              </div>
              <div>
                <label className="text-xs font-semibold text-slate-400 uppercase tracking-wider mb-2 block">İnşaat Alanı (m²)</label>
                <input type="text" value={form.stat_area} onChange={(e) => setForm({ ...form, stat_area: e.target.value })} className="admin-input" data-testid="about-stat-area" />
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
